import { render, staticRenderFns } from "./ClearBlockedUsersPopup.vue?vue&type=template&id=0063006f&scoped=true&"
import script from "./ClearBlockedUsersPopup.vue?vue&type=script&lang=ts&"
export * from "./ClearBlockedUsersPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ClearBlockedUsersPopup.vue?vue&type=style&index=0&id=0063006f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063006f",
  null
  
)

export default component.exports